import { render, staticRenderFns } from "./UIFrame.vue?vue&type=template&id=11390c8e&scoped=true&"
import script from "./UIFrame.vue?vue&type=script&lang=js&"
export * from "./UIFrame.vue?vue&type=script&lang=js&"
import style0 from "./UIFrame.vue?vue&type=style&index=0&id=11390c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11390c8e",
  null
  
)

export default component.exports